module.exports = __webpack_public_path__ + "chip.b7df4471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/chip.png
// module id = 347
// module chunks = 0